/**
 * Attach tag info to a custom tree
 * @param {*} tree Custom Tree
 * @param {*} contentTagsMapById Map of visible content tags to the user
 * @returns
 */
export const attachTagInfoToTree = (tree, contentTagsMapById) => {
  const copyOfTree = JSON.parse(JSON.stringify(tree));

  const attachInfo = (listOfTags) => {
    return listOfTags.reduce((pv, tag) => {
      const foundTag = contentTagsMapById[tag.contentTagId];
      if (!foundTag) return pv;

      const tagWithInfo = {
        ...foundTag,
        ...tag,
      };

      if (tag.children?.length) {
        tagWithInfo.children = attachInfo(tag.children);
      }

      return [...pv, tagWithInfo];
    }, []);
  };

  return attachInfo(copyOfTree);
};
